/**
 * Fix broken / locale-prefixed theme media URLs.
 * - Strips /en|/pt-pt|/de|/fr… prefixes before /cdn|/assets|/files
 * - Remaps ONLY known Translate & Adapt rewritten THEME asset basenames
 *   (paths under /assets/). Never touches product/collection CDN files.
 *
 * Load with defer (non-blocking). Observer watches added media nodes only.
 */
(function () {
  if (window.__wod3dFixMediaUrlsBooted) return;
  window.__wod3dFixMediaUrlsBooted = true;

  var MEDIA_SEL = 'img, video, source, image, use';

  var LOCALE_MEDIA_RE =
    /^(\/(?:en|es|fr|de|pt(?:-pt|-br)?|it|nl|da|sv|fi|pl|cs|hu|ro|el|sk|sl|hr|bg|lt|lv|et|ja|ko|zh(?:-cn|-tw)?|id|th|vi|tr|nb|ar|he)(?=[\/?#]|$))(\/(?:cdn|assets|files|shop)\b.*)$/i;

  // Exact basenames from Translate & Adapt rewriting theme text settings.
  // Do NOT use fuzzy keywords (parche/patch/…) — that breaks product gallery files.
  var BASENAME_REMAP = {
    'personalized-keychains-crossfit.webp': 'llaveros-personalizados-crossfit.webp',
    'personalized-keychain-crossfit.webp': 'llaveros-personalizados-crossfit.webp',
    'custom-keychains-crossfit.webp': 'llaveros-personalizados-crossfit.webp',
    'velcro-patches-personalized-crossfit-wod3d.webp': 'parches-velcro-personalizados-crossfit-WOD3D.webp',
    'personalized-velcro-patches-crossfit-wod3d.webp': 'parches-velcro-personalizados-crossfit-WOD3D.webp',
    'crossfit-backpack-patches.webp': 'parches-mochila-crossfit.webp',
    'purple-bg.mp4': 'bg-morado.mp4',
    'purple-background.mp4': 'bg-morado.mp4',
    'background-purple.mp4': 'bg-morado.mp4',
  };

  function isThemeAssetPath(pathname) {
    var p = String(pathname || '');
    return /\/cdn\/shop\/t\/[^/]+\/assets\//i.test(p) || /^\/assets\//i.test(p);
  }

  function basenameOfPath(pathname) {
    var path = String(pathname || '').split('?')[0];
    return path.split('/').pop() || '';
  }

  function remapThemeBasename(pathname) {
    if (!isThemeAssetPath(pathname)) return '';
    var base = basenameOfPath(pathname);
    if (!base) return '';
    return BASENAME_REMAP[base] || BASENAME_REMAP[base.toLowerCase()] || '';
  }

  function fixUrl(url) {
    if (!url || typeof url !== 'string') return url;
    var trimmed = url.trim();
    if (!trimmed || trimmed.indexOf('data:') === 0 || trimmed.indexOf('blob:') === 0) return url;

    try {
      if (/^(https?:)?\/\//i.test(trimmed)) {
        var abs = new URL(trimmed, window.location.origin);
        var pathFixed = abs.pathname.replace(LOCALE_MEDIA_RE, '$2');
        if (pathFixed !== abs.pathname) abs.pathname = pathFixed;

        var mappedAbs = remapThemeBasename(abs.pathname);
        if (mappedAbs) {
          abs.pathname = abs.pathname.replace(/\/[^/]+$/, '/' + mappedAbs);
          abs.search = '';
        }
        return abs.toString();
      }

      var out = trimmed;
      var m = out.match(LOCALE_MEDIA_RE);
      if (m) out = m[2];

      if (/^(cdn|assets|files|shop)\//i.test(out)) {
        out = '/' + out.replace(/^\/+/, '');
      }

      if (isThemeAssetPath(out) || /^\/?assets\//i.test(out)) {
        var pathForCheck = out.charAt(0) === '/' ? out : '/' + out;
        var mapped = remapThemeBasename(pathForCheck.replace(/^\/(?!assets\/)/, '/'));
        var base = basenameOfPath(out);
        var exact = BASENAME_REMAP[base] || BASENAME_REMAP[base.toLowerCase()] || mapped;
        if (exact && exact !== base) {
          out = out.replace(/\/[^/?]+(\?.*)?$/, '/' + exact);
        }
      }

      return out;
    } catch (_) {
      return url;
    }
  }

  function fixSrcset(value) {
    if (!value) return value;
    return value
      .split(',')
      .map(function (part) {
        var bit = part.trim();
        if (!bit) return bit;
        var pieces = bit.split(/\s+/);
        pieces[0] = fixUrl(pieces[0]);
        return pieces.join(' ');
      })
      .join(', ');
  }

  function fixElement(el) {
    if (!el || el.nodeType !== 1) return;

    ['src', 'data-src', 'poster', 'data-poster'].forEach(function (attr) {
      if (!el.hasAttribute(attr)) return;
      var next = fixUrl(el.getAttribute(attr));
      if (next && next !== el.getAttribute(attr)) el.setAttribute(attr, next);
    });

    if (el.hasAttribute('srcset')) {
      var nextSet = fixSrcset(el.getAttribute('srcset'));
      if (nextSet && nextSet !== el.getAttribute('srcset')) el.setAttribute('srcset', nextSet);
    }
    if (el.hasAttribute('data-srcset')) {
      var nextDataSet = fixSrcset(el.getAttribute('data-srcset'));
      if (nextDataSet && nextDataSet !== el.getAttribute('data-srcset')) {
        el.setAttribute('data-srcset', nextDataSet);
      }
    }
  }

  function isMediaEl(el) {
    if (!el || el.nodeType !== 1) return false;
    var tag = el.tagName;
    return (
      tag === 'IMG' ||
      tag === 'VIDEO' ||
      tag === 'SOURCE' ||
      tag === 'IMAGE' ||
      tag === 'USE'
    );
  }

  function scan(root) {
    if (!root) return;
    if (isMediaEl(root)) fixElement(root);
    if (!root.querySelectorAll) return;
    var nodes = root.querySelectorAll(MEDIA_SEL);
    for (var i = 0; i < nodes.length; i++) fixElement(nodes[i]);
  }

  function processAddedNode(node) {
    if (!node || node.nodeType !== 1) return;
    if (isMediaEl(node)) {
      fixElement(node);
      // <video> may bring nested <source>
      if (node.tagName === 'VIDEO' && node.querySelectorAll) {
        var sources = node.querySelectorAll('source');
        for (var i = 0; i < sources.length; i++) fixElement(sources[i]);
      }
      return;
    }
    // Only descend when the subtree likely contains media.
    if (node.querySelector && node.querySelector(MEDIA_SEL)) scan(node);
  }

  function boot() {
    scan(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  // childList only — attribute observation re-fired on our own setAttribute fixes.
  var mo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      if (!added || !added.length) continue;
      for (var j = 0; j < added.length; j++) processAddedNode(added[j]);
    }
  });
  mo.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  window.wod3dFixMediaUrls = { fixUrl: fixUrl, scan: scan, BASENAME_REMAP: BASENAME_REMAP };
})();
